import { jwtDecode } from "jwt-decode";
import safeLogger from "./safeLogger";

export const isTokenValid = (token) => {
  try {
    if (!token) {
      safeLogger.warn("Token ausente ou nulo.");
      return false; // Token ausente
    }

    const decoded = jwtDecode(token);

    if (!decoded.exp) {
      safeLogger.warn("Token sem tempo de expiração.");
      return false; // Token inválido sem 'exp'
    }

    const isValid = decoded.exp * 1000 > Date.now(); // Verifica se o token não expirou

    return isValid;
  } catch (error) {
    return false; // Token malformado ou inválido
  }
};
